/**
 * Function to setup a redux store with the application's
 * middlewares.
 */

import {configureStore} from '@reduxjs/toolkit';
import reducers from './reducers/index.js';

const store = configureStore({
  reducer: reducers,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      // WARNING! The checks here are valuable but they have a
      // significant impact on performance.
      serializableCheck: false,
      immutableCheck: false,
    }),
  devTools:
    import.meta.env.DEV ||
    window.location.hostname === 'static.prod.planet-labs.com',
});
export default store;
